import { ArrowRight, Code, Layout, Palette, Rocket, Shield } from "lucide-react";

export const ProcessSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Development Process</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We follow a proven development methodology that ensures your project is delivered 
            on time, within budget, and exceeds expectations.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              icon: <Layout className="h-12 w-12 text-blue-600" />,
              title: "Discovery & Planning",
              description: "We start by understanding your business goals, target audience, and project requirements to create a comprehensive development plan."
            },
            {
              icon: <Palette className="h-12 w-12 text-blue-600" />,
              title: "Design & Prototyping",
              description: "Our designers create stunning, user-friendly interfaces that align with your brand and optimize the user experience."
            },
            {
              icon: <Code className="h-12 w-12 text-blue-600" />,
              title: "Development",
              description: "Our developers bring the designs to life using clean, efficient code and the latest web technologies."
            },
            {
              icon: <Shield className="h-12 w-12 text-blue-600" />,
              title: "Testing & QA",
              description: "Rigorous testing ensures your website functions flawlessly across all devices and browsers."
            },
            {
              icon: <Rocket className="h-12 w-12 text-blue-600" />,
              title: "Launch",
              description: "We handle the deployment process and ensure your website launches smoothly and securely."
            },
            {
              icon: <ArrowRight className="h-12 w-12 text-blue-600" />,
              title: "Ongoing Support",
              description: "Our team provides continuous support and maintenance to keep your website running optimally."
            }
          ].map((step, index) => (
            <div key={index} className="p-6 rounded-xl border border-gray-200 hover:shadow-lg transition-shadow">
              <div className="mb-4">{step.icon}</div>
              <h3 className="text-xl font-semibold mb-3 text-gray-900">{step.title}</h3>
              <p className="text-gray-600">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};